import { Query } from 'graphql/generated/graphqlTypes';
import { generateMockAccessGrant } from 'mocks/graphqlMocks/accessGrant';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';

export function mockedGetAllVisitorsGroupsWithoutNestedResolversData(
  getVisitorGroupsForTenant: Query['getVisitorGroupsForTenant']
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return { getVisitorGroupsForTenant };
}

const officeHoursSchedule = {
  __typename: 'WeekSchedule' as const,
  weekDays: [{ __typename: 'WeekScheduleDay' as const, dayName: 'monday', from: '09:00', to: '17:00' }]
};

export const mockedGetAllVisitorsGroupsWithoutNestedResolversDataForQuery =
  mockedGetAllVisitorsGroupsWithoutNestedResolversData([
    generateMockVisitorGroup({
      id: 'mockedIdInstallers',
      name: 'installers',
      type: 'INSTALLERS',
      memberIds: ['mockVisitorId1'],
      accessGrants: [
        generateMockAccessGrant({
          id: 'mockedAccessGrantIdInstallers',
          accessSchedule: officeHoursSchedule,
          isOfficeModeEnabled: true,
          locationIds: ['TestGroup1'],
          doorIds: ['mockedDoorId1']
        })
      ]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdCleaners',
      name: 'cleaners',
      type: 'CO_CONTRACTORS',
      memberIds: ['mockVisitorId2'],
      accessGrants: [
        generateMockAccessGrant({
          id: 'mockedAccessGrantIdCleaners',
          doorIds: ['mockedDoorId2']
        })
      ]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdCo-contractors',
      name: 'co-contractors',
      type: 'CO_CONTRACTORS',
      memberIds: ['mockVisitorId13', 'mockVisitorId14'],
      accessGrants: [
        generateMockAccessGrant({
          id: 'mockedAccessGrantIdCo-contractors',
          accessSchedule: officeHoursSchedule,
          isOfficeModeEnabled: true,
          locationIds: ['TestGroup1']
        })
      ]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdAdmins',
      name: 'admins',
      type: 'ADMINISTRATORS',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdAdmins' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdEmployees',
      name: 'employees',
      type: 'AZURE_AD',
      memberIds: ['mockVisitorId2'],
      accessGrants: [
        generateMockAccessGrant({
          id: 'mockedAccessGrantIdEmployees',
          accessSchedule: officeHoursSchedule,
          isOfficeModeEnabled: true,
          doorIds: ['mockedDoorId1']
        })
      ]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdVisitor_group_1',
      name: 'visitor_group_1',
      type: 'AZURE_AD',
      memberIds: ['mockVisitorId1'],
      accessGrants: [
        generateMockAccessGrant({
          id: 'mockedAccessGrantIdVisitor_group_1',
          doorIds: ['mockedDoorId2']
        })
      ]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdVisitor_group_2',
      name: 'visitor_group_2',
      type: 'AZURE_AD',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdVisitor_group_2' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdVisitor_group_3',
      name: 'visitor_group_3',
      type: 'AZURE_AD',
      memberIds: ['mockVisitorId2'],
      accessGrants: [
        generateMockAccessGrant({
          id: 'mockedAccessGrantIdVisitor_group_3',
          accessSchedule: officeHoursSchedule,
          locationIds: ['TestGroup1']
        })
      ]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdCognitoTeam',
      name: 'cognito team',
      memberIds: ['mockVisitorId8'],
      type: 'CO_CONTRACTORS',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdCognitoTeam' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdInternalTeam',
      name: 'internal team',
      memberIds: ['mockVisitorId9'],
      type: 'CO_CONTRACTORS',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdInternalTeam' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdKeySharingUsers',
      name: 'key sharing users',
      memberIds: ['mockVisitorId10'],
      type: 'CO_CONTRACTORS',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdKeySharingUsers' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdEntraTeam',
      name: 'entra team',
      type: 'AZURE_AD',
      memberIds: ['mockVisitorId11'],
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdEntraTeam' })]
    }),
    generateMockVisitorGroup({
      id: 'mockedIdCardHolders',
      name: 'card holders',
      memberIds: ['mockVisitorId12'],
      type: 'AZURE_AD',
      accessGrants: [generateMockAccessGrant({ id: 'mockedAccessGrantIdCardHolders' })]
    })
  ]);
